// import React from 'react';
// import { motion } from 'motion/react';
// import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

// export function Footer() {
//   const footerLinks = {
//     info: [
//       { label: 'About Us', href: '#about-us' },
//       { label: 'Features', href: '#features' },
//       { label: 'How It Works', href: '#how-it-works' },
//       { label: 'Pricing', href: '#pricing' },
//     ],
//     support: [
//       { label: 'Help Center', href: '#' },
//       { label: 'Contact Us', href: '#contact' },
//       { label: 'FAQ', href: '#' },
//       { label: 'Privacy Policy', href: '#' },
//     ],
//   };

//   const socialLinks = [
//     { icon: Facebook, href: '#', label: 'Facebook' },
//     { icon: Twitter, href: '#', label: 'Twitter' },
//     { icon: Instagram, href: '#', label: 'Instagram' },
//     { icon: Linkedin, href: '#', label: 'LinkedIn' },
//   ];

//   return (
//     <footer className="bg-card/50 backdrop-blur-sm border-t border-border">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20 py-12 lg:py-16">
//         <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
//           {/* Logo & Description */}
//           <div className="lg:col-span-1">
//             <motion.h2
//               className="text-2xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent mb-4"
//               whileHover={{ scale: 1.05 }}
//             >
//               NFC Design Studio
//             </motion.h2>
//             <p className="text-muted-foreground text-sm leading-relaxed mb-4">
//               Revolutionizing business networking with smart, eco-friendly digital business cards.
//             </p>
//             <div className="space-y-2 text-sm text-muted-foreground">
//               <div className="flex items-center gap-2">
//                 <Mail className="w-4 h-4 text-primary" />
//                 <span>hello@nfcstudio.com</span>
//               </div>
//               <div className="flex items-center gap-2">
//                 <Phone className="w-4 h-4 text-primary" />
//                 <span>+1 (555) 000-0000</span>
//               </div>
//               <div className="flex items-center gap-2">
//                 <MapPin className="w-4 h-4 text-primary" />
//                 <span>San Francisco, CA</span>
//               </div>
//             </div>
//           </div>

//           {/* Info Links */}
//           <div>
//             <h3 className="font-semibold text-foreground mb-4">Info</h3>
//             <ul className="space-y-3">
//               {footerLinks.info.map((link) => (
//                 <li key={link.label}>
//                   <a
//                     href={link.href}
//                     className="text-muted-foreground hover:text-primary transition-colors text-sm"
//                   >
//                     {link.label}
//                   </a>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* Support Links */}
//           <div>
//             <h3 className="font-semibold text-foreground mb-4">Support</h3>
//             <ul className="space-y-3">
//               {footerLinks.support.map((link) => (
//                 <li key={link.label}>
//                   <a
//                     href={link.href}
//                     className="text-muted-foreground hover:text-primary transition-colors text-sm"
//                   >
//                     {link.label}
//                   </a>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* Social Links */}
//           <div>
//             <h3 className="font-semibold text-foreground mb-4">Connect</h3>
//             <div className="flex gap-3">
//               {socialLinks.map((social) => (
//                 <motion.a
//                   key={social.label}
//                   href={social.href}
//                   aria-label={social.label}
//                   className="w-10 h-10 rounded-lg bg-muted hover:bg-gradient-to-br hover:from-primary hover:to-accent flex items-center justify-center text-muted-foreground hover:text-white transition-all duration-300 shadow-md hover:shadow-lg"
//                   whileHover={{ scale: 1.1, y: -2 }}
//                   whileTap={{ scale: 0.95 }}
//                 >
//                   <social.icon className="w-5 h-5" />
//                 </motion.a>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Bottom Bar */}
//         <div className="mt-12 pt-8 border-t border-border">
//           <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
//             <p className="text-sm text-muted-foreground text-center sm:text-left">
//               © 2026 eMedha Technologies — All Rights Reserved
//             </p>
//             <div className="flex gap-6 text-sm">
//               <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
//                 Terms of Service
//               </a>
//               <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
//                 Privacy Policy
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }





import React from 'react';
import { motion } from 'framer-motion';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const footerLinks = {
  info: [
    { label: 'About Us', href: '#about-us' },
    { label: 'Features', href: '#features' },
    { label: 'How It Works', href: '#how-it-works' },
    { label: 'Pricing', href: '#pricing' },
  ],
  support: [
    { label: 'Help Center', href: '#' },
    { label: 'Contact Us', href: '#contact' },
    { label: 'FAQ', href: '#' },
    { label: 'Privacy Policy', href: '#' },
  ],
};

const socialLinks = [
  { icon: Facebook, href: '#', label: 'Facebook' },
  { icon: Twitter, href: '#', label: 'Twitter' },
  { icon: Instagram, href: '#', label: 'Instagram' },
  { icon: Linkedin, href: '#', label: 'LinkedIn' },
];

const Footer = () => {
  return (
    <footer
      style={{
        background: 'rgba(255,255,255,0.5)',
        backdropFilter: 'blur(8px)',
        borderTop: '1px solid #e5e7eb',
        padding: '48px 16px',
      }}
    >
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '32px',
        }}
      >
        {/* Logo & Contact Info */}
        <div>
          <motion.h2 whileHover={{ scale: 1.05 }} style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '16px', background: 'linear-gradient(to right, #8b5cf6, #ec4899)', WebkitBackgroundClip: 'text', color: 'transparent', }}>
            NFC Design Studio
          </motion.h2>
          <p style={{ fontSize: '0.875rem', color: '#888888', lineHeight: 1.5, marginBottom: '16px' }}>
            Revolutionizing business networking with smart, eco-friendly digital business cards.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '0.875rem', color: '#888888' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Mail style={{ width: '16px', height: '16px', color: '#8b5cf6' }} /> hello@nfcstudio.com
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Phone style={{ width: '16px', height: '16px', color: '#8b5cf6' }} /> +1 (555) 000-0000
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <MapPin style={{ width: '16px', height: '16px', color: '#8b5cf6' }} /> San Francisco, CA
            </div>
          </div>
        </div>

        {/* Info Links */}
        <div>
          <h3 style={{ fontWeight: 600, marginBottom: '16px' }}>Info</h3>
          <ul style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {footerLinks.info.map(link => (
              <li key={link.label}>
                <a href={link.href} style={{ fontSize: '0.875rem', color: '#888888', textDecoration: 'none' }} onMouseEnter={e => (e.target.style.color = '#8b5cf6')} onMouseLeave={e => (e.target.style.color = '#888888')}>
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Support Links */}
        <div>
          <h3 style={{ fontWeight: 600, marginBottom: '16px' }}>Support</h3>
          <ul style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {footerLinks.support.map(link => (
              <li key={link.label}>
                <a
                  href={link.href}
                  style={{ fontSize: '0.875rem', color: '#888888', textDecoration: 'none' }}
                  onMouseEnter={e => (e.target.style.color = '#8b5cf6')}
                  onMouseLeave={e => (e.target.style.color = '#888888')}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Social Links */}
        <div>
          <h3 style={{ fontWeight: 600, marginBottom: '16px' }}>Connect</h3>
          <div style={{ display: 'flex', gap: '12px' }}>
            {socialLinks.map(social => {
              const Icon = social.icon;
              return (
                <motion.a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  whileHover={{ scale: 1.1, y: -2 }}
                  whileTap={{ scale: 0.95 }}
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '8px',
                    background: '#f5f5f5',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#888888',
                    textDecoration: 'none',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.05)',
                  }}
                >
                  <Icon style={{ width: '20px', height: '20px' }} />
                </motion.a>
              );
            })}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div
        style={{
          marginTop: '48px',
          paddingTop: '32px',
          borderTop: '1px solid #e5e7eb',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          alignItems: 'center',
        }}
      >
        <p style={{ fontSize: '0.875rem', color: '#888888', textAlign: 'center' }}>
          © 2026 eMedha Technologies — All Rights Reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
